export default __webpack_public_path__ + "static/media/metopera-logo.f8e3f805.svg";